import { Box, Button, Typography } from '@mui/material';
import { AtrIcon } from 'images/icons/AtrIcon';
import {
  ACTIVE_ICON_COLOR,
  PURPLE_ICON_COLOR,
} from 'components/TeamOverview/CardsMenuSection/CardsMenuSection';
import { useHistory } from 'react-router';
import { TEAM_MEMBERS_SECTION } from 'components/TeamOverview/constants';
import { TEAM_OVERVIEW_URL } from 'constants/urls';

export const TeamMembersButton = ({ isActive, classes }) => {
  const history = useHistory();
  const iconColor = isActive ? ACTIVE_ICON_COLOR : PURPLE_ICON_COLOR;
  const handleTeamMembersClick = () => {
    history.push(`${TEAM_OVERVIEW_URL}#${TEAM_MEMBERS_SECTION}`);
  };

  return (
    <Button
      display="flex"
      className={classes.teamButton}
      onClick={() => handleTeamMembersClick()}
    >
      <Box className={classes.teamIconBox}>
        <AtrIcon color={iconColor} className={classes.teamIcon} />
      </Box>
      <Typography className={classes.teamButtonTitle}>Team Members</Typography>
    </Button>
  );
};
